import React from 'react'

const LargePlayButton = (props) => {
  return (
    <svg width="138" height="138" viewBox="0 0 138 138" style={{ cursor: 'pointer' }} fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_22723_9)">
      <path d="M68.7319 137.035C106.098 137.035 137.035 106.031 137.035 68.732C137.035 31.3661 106.031 0.428572 68.665 0.428572C31.366 0.428572 0.428467 31.3661 0.428467 68.732C0.428467 106.031 31.4329 137.035 68.7319 137.035ZM56.0088 95.7189C52.7945 97.6606 49.1115 96.1206 49.1115 92.7726V44.7589C49.1115 41.4777 53.0624 40.0714 56.0088 41.8125L95.317 65.116C98.1296 66.7903 98.1965 70.808 95.317 72.5491L56.0088 95.7189Z" fill="white"/>
      </g>
      <defs>
      <clipPath id="clip0_22723_9">
      <rect width="136.607" height="136.674" fill="white" transform="translate(0.428467 0.428572)"/>
      </clipPath>
      </defs>
    </svg>
  )
}

export default LargePlayButton